module.exports = __webpack_public_path__ + "img/port_centrion_calcados.bc77ee02.png";